import { doc, getDoc } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import { db, functions } from './firebase';
import { PLATFORM_FEE_PERCENT } from './rentalPayments';

export const FOUNDING_LISTER_CAP_DEFAULT = 20;

export function clampFeePercent(value, fallback = PLATFORM_FEE_PERCENT) {
  const n = Number(value);
  if (!Number.isFinite(n)) return fallback;
  return Math.min(100, Math.max(0, n));
}

export function isPromoActive(settings, now = new Date()) {
  if (!settings || settings.promoFeePercent === null || settings.promoFeePercent === undefined) {
    return false;
  }
  const start = settings.promoStartsAt ? new Date(settings.promoStartsAt) : null;
  const end = settings.promoEndsAt ? new Date(settings.promoEndsAt) : null;
  if (start && Number.isNaN(start.getTime())) return false;
  if (end && Number.isNaN(end.getTime())) return false;
  if (start && now < start) return false;
  if (end && now > end) return false;
  return true;
}

export function getEffectivePlatformFeePercent(settings, now = new Date()) {
  if (isPromoActive(settings, now)) {
    return clampFeePercent(settings.promoFeePercent, 0);
  }
  return clampFeePercent(settings?.defaultPlatformFeePercent, PLATFORM_FEE_PERCENT);
}

export function getOwnerSharePercent(platformFeePercent) {
  return 100 - clampFeePercent(platformFeePercent, PLATFORM_FEE_PERCENT);
}

/** Owner share for display: uses rental snapshot when present. */
export function getRentalOwnerSharePercent(rental, ownerProfile) {
  if (rental?.platformFeePercentApplied !== undefined && rental?.platformFeePercentApplied !== null) {
    return getOwnerSharePercent(rental.platformFeePercentApplied);
  }
  if (rental?.ownerPlatformFeeExempt || ownerProfile?.platformFeeExempt) {
    return 100;
  }
  return 100 - PLATFORM_FEE_PERCENT;
}

export async function fetchPlatformFeeSettingsAdmin() {
  const callable = httpsCallable(functions, 'getPlatformFeeSettings');
  const result = await callable({});
  return result.data;
}

export async function savePlatformFeeSettingsAdmin(patch) {
  const callable = httpsCallable(functions, 'updatePlatformFeeSettings');
  const result = await callable(patch);
  return result.data;
}

export async function setOwnerFeeExemptAdmin({ userId, exempt, reason }) {
  const callable = httpsCallable(functions, 'setOwnerPlatformFeeExempt');
  const result = await callable({ userId, exempt, reason });
  return result.data;
}

export async function fetchMyPlatformFeeStatus() {
  const callable = httpsCallable(functions, 'getMyPlatformFeeStatus');
  const result = await callable({});
  return result.data;
}

export async function fetchUserFeeExemptFlag(userId) {
  if (!userId) return false;
  const snap = await getDoc(doc(db, 'users', userId));
  if (!snap.exists()) return false;
  return Boolean(snap.data()?.platformFeeExempt);
}
